import { Component, ViewContainerRef} from '@angular/core';
import { DiscountType } from '../../../models/coupons/discount-type-model';
import { DiscountTypeService } from '../../../services/coupons/discount-type.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../../services/role/role-permission.service';

@Component({
    selector: 'app-edit-discount-type',
    templateUrl: './edit-discount-type.component.html',
    styleUrls: ['./edit-discount-type.component.scss']
})
/** edit-discount-type component*/
export class EditDiscountTypeComponent {
  public discountTypeModel =new DiscountType();
  discountTypeID: string;
  validate: boolean;
    /** edit-discount-type ctor */
  constructor(private readonly discountTypeService: DiscountTypeService, private readonly activatedRoute: ActivatedRoute,
    public toastr: ToastsManager, vcr: ViewContainerRef, private _router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("discountype").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            this.activatedRoute.params.subscribe((params: Params) => {
              this.discountTypeID = params['id'];
            });
            this.getdiscountType(this.discountTypeID);
            this.toastr.setRootViewContainerRef(vcr);
            this.validate = true;
          }
          else {
            this._router.navigate(["/discount-types"]);
          }
        }
        else {
          this._router.navigate(["/discount-types"]);
        }
      }
    )

  }
  isActiveCheckbox(e) {
    this.discountTypeModel.isActive = e.target.checked;
  }
  onSubmit() {
    this.validate = false;
    this.discountTypeService.updateDiscountType(this.discountTypeModel).subscribe(result => {
      if (result) {
        this.toastr.success('Discount Type has been Updated. ', 'Success');
        setTimeout(() => {
          this._router.navigate(["/discount-types"]);
        }, 2000);
      }
      else {
        this.toastr.error('Error occurred. Oop!', 'Error');
      }
    });
  }
  getdiscountType(discountTypeID: string) {
    this.discountTypeService.getDiscountType(discountTypeID).subscribe(
      data => {
        this.discountTypeModel = data
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/coupons/discount-type/edit-discount-type/edit-discount-type.component.ts